<template>
  <div class="content-container">
    <el-form :model="formInline" label-width="150px" class="demo-form-inline">
      <el-row>
        <el-col :span="12">
          <el-form-item label="机器号">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formInline.machineIDs"
              placeholder="机器号，多个逗号分割"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="时间间隔（秒）">
            <el-input
              v-model="formInline.interval"
              placeholder="建议值600"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" icon="el-icon-circle-check" @click="onSubmit"
          >确定</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {
        machineIDs: "",
        interval: "600"
      }
    };
  },

  methods: {
    onSubmit() {
      let request = {
        machineIDs: this.formInline.machineIDs.split(","),
        interval: this.formInline.interval
      };
      this.$axios(this.$urlMapping["心跳设置"], {
        data: request
      });
    }
  }
};
</script>
